<div class="warp">
    <div class="numbers ">
        <ng-container *ngFor="let num of numberRange">
            <div class="num pointer" *ngIf="num<=(question?.toNum??1) && num>=(question?.fromNum??10)"
                [ngClass]="{'select':answer.value==num}" (click)="select(num)">{{num}}</div>
        </ng-container>
    </div>
</div>